// extracted by mini-css-extract-plugin
export default {"backdrop":"AvatarsList_backdrop__cHbjP","modal":"AvatarsList_modal__wOg7V","close":"AvatarsList_close__b5psn","checkmark":"AvatarsList_checkmark__IoVrj"};